<mat-sidenav-container class="mt-4 example-container">
  <mat-sidenav #sidenav class="example-sidenav bg-slate-100" mode="over" position="end">
    <div class="ps-2 ms-2 d-flex flex-column">
      <app-filtro-modifiche [attore]="attore" (searchEvent)="search($event)"
        [commesse]="commesse" [uoPrimoLivello]="uoPrimoLivello"></app-filtro-modifiche>
    </div>
  </mat-sidenav>
  <mat-sidenav-content class="example-content">
    <div class="d-flex justify-content-end mb-2">
      <button type="button" class="btn btn-primary fw-semibold" (click)="goBack()">
        <i class="bi bi-arrow-left"></i>
        Indietro
      </button>
    </div>

    <div class="rounded bg-white shadow-sm mt-2 mb-4 pb-3 pt-4 px-4 w-100">
      <div class="row g-3 mb-3">
        <h5 class="fw-bold">Riepilogo modifiche</h5>
        <div class="col-4">
          <button type="button" class="btn btn-outline-primary fw-semibold" title="Filtra" (click)="sidenav.toggle()">
            <i class="bi bi-funnel-fill me-1"></i>
            Filtra
          </button>
          @if (elencoModifiche.length > 0) {
          <button (click)="exportDataToExcel()" type="button" class="btn btn-outline-primary ms-3 fw-semibold">
            <i class="bi bi-file-earmark-spreadsheet-fill me-1"></i>
            Esporta in Excel
          </button>
          }
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12">
          @if (elencoModifiche.length > 0) {
          <app-tabella-modifiche #tabellaModificheComponent [modifiche]="elencoModifiche" [attore]="attore"
            [isDettaglio]="false" [elencoCount]="elencoCount"
            [anagraficaTimesheet]="anagraficaTimesheet" (iconItemEvent)="iconClick($event)">
          </app-tabella-modifiche>
          } @else {
          <p class="w-100 text-center">Nessuna richiesta presente</p>
          }
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
